import { route } from 'ziggy-js';

type WarehouseInventoryRouteName =
  | 'warehouse.inventory.adjustmentHistory.index'
  | 'warehouse.inventory.adjustments.index'
  | 'warehouse.inventory.adjustments.update'
  | 'warehouse.inventory.destroy.index'
  | 'warehouse.inventory.destroy.store'
  | 'warehouse.inventory.restore'
  | 'warehouse.inventory.receipts.index'
  | 'warehouse.inventory.receipts.update'
  | 'warehouse.inventory.creative.update';

const warehouseInventoryRoute = (name: WarehouseInventoryRouteName, productionOrder: number): string => route(
  name,
  { productionOrder } as never,
  true,
);

export const useWarehouseInventoryRoutes = () => ({
  adjustmentHistory: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.adjustmentHistory.index', productionOrder),
  adjustments: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.adjustments.index', productionOrder),
  updateAdjustments: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.adjustments.update', productionOrder),
  destroyRows: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.destroy.index', productionOrder),
  destroyInventory: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.destroy.store', productionOrder),
  restoreInventory: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.restore', productionOrder),
  receipts: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.receipts.index', productionOrder),
  updateReceipts: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.receipts.update', productionOrder),
  updateCreative: (productionOrder: number): string => warehouseInventoryRoute('warehouse.inventory.creative.update', productionOrder),
});
